import { render, staticRenderFns } from "./IconAddToFolder.vue?vue&type=template&id=6412a984&scoped=true"
import script from "./IconAddToFolder.vue?vue&type=script&lang=js"
export * from "./IconAddToFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412a984",
  null
  
)

export default component.exports